export interface DiagnosticTemplateId {__diagnosticTemplateId: number}

export default class DiagnosticTemplate {
  id!: DiagnosticTemplateId;
  description = '';
  countOfSteps = 0;
}
